import fireApp from '../fireConfig.js'

export function getAllRegistros(callback) {

    fireApp.database().ref('website').child('registrados').once('value').then(function(snapshot){
       var registros = snapshot.val();
       callback(registros);
    })
}

export function getAllSuscripciones(callback) {

    fireApp.database().ref('website').child('suscriptos').once('value').then(function(snapshot){
       var suscripciones = snapshot.val();
       callback(suscripciones);
    })
}


// WEBPACK FOOTER //
// ./E:/dev/repos/wpo_sitecontrol/src/services/website/website.service.js